import { InputHTMLAttributes, useEffect, useState } from 'react';
import { NationMenuItem } from '@/types/order';
import { FormattedMessage } from 'react-intl';
import { Image } from '@/components/Image';

interface NationSelectProps extends InputHTMLAttributes<HTMLInputElement> {
  menuClassName?: string;
  menus: NationMenuItem[];
  onMenuSelect?: (code: string, codeNumber: string) => void;
  defaultValue?: string;
  inputContainerClassName?: string;
  menuValue?: string;
}

export const NationSelect = ({ onMenuSelect, menuClassName, menus, menuValue }: NationSelectProps) => {
  const [isOptionVisible, setIsOptionVisible] = useState(false);
  const fistValue = menus?.filter((i) => i.code === menuValue);
  const [clickOption, setClickOption] = useState('');
  const handleClick = (name: string, codeNumber: string, code: string) => {
    setClickOption(`${name} +${codeNumber}`);
    onMenuSelect?.(code, codeNumber);
  };
  const [searchMenus, setSearchMenus] = useState(menus);
  const [searchValue, setSearchValue] = useState<string>();

  const handleSearchValue = (value: string) => {
    setSearchValue(value);
    setSearchMenus(menus.filter((menuItem) => menuItem.name.toLocaleUpperCase().includes(value.toLocaleUpperCase())));
  };

  useEffect(() => {
    if (menuValue) setClickOption(`${fistValue[0]?.name} +${fistValue[0]?.number}`);
  }, [menuValue]);

  return (
    <>
      <div
        className="relative px-5 flex items-center justify-between border border-[#dadada] rounded-[10px] w-[320px] h-[52px] gap-8 cursor-pointer"
        onClick={() => {
          setIsOptionVisible((pev) => !pev);
          handleSearchValue('');
        }}
      >
        <div className={`${menuClassName ?? ''}`}>
          <span className="text-[14px] leading-5 font-semibold">{menuValue ? clickOption : 'Select nation'}</span>
        </div>
        <Image
          src="/icons/arrow-down.svg"
          alt="arrow icon"
          className="transition ease-in-out duration-300 cursor-pointer"
          style={{ transform: isOptionVisible ? 'rotate(180deg)' : 'rotate(0)' }}
          width={15}
          height={15}
        />
      </div>
      {isOptionVisible && (
        <div className="w-[320px] min-h-[52px] max-h-[368px] absolute top-[97px] left-0 border-[1.5px] border-[#f5f5f5] rounded-[10px] shadow-[0_4px_10px_rgba(0,0,0,0.16)] bg-white flex flex-col z-[9] overflow-hidden">
          <div className="bg-white flex items-center justify-between p-4 w-[315px] h-[56px] gap-2 border-b border-[#f5f5f5]">
            <div className="flex items-center gap-2">
              <Image src="/icons/search.svg" alt="search-icon" width={24} height={24} />
              <input
                id="select-name"
                type="text"
                placeholder="Search"
                value={searchValue}
                onChange={({ target }) => handleSearchValue(target.value)}
                className="w-[224px] text-[13px] font-semibold outline-none placeholder:text-[#dadada] placeholder:text-[13px] placeholder:font-semibold"
              />
            </div>
            {searchValue && (
              <Image src="/icons/huge.svg" alt="huge-svg" onClick={() => handleSearchValue('')} height={16} width={16} />
            )}
          </div>
          <ul className="overflow-auto max-h-[312px]" style={{ scrollbarWidth: 'thin' }}>
            {searchMenus.map((item) => (
              <>
                <li
                  key={item.id}
                  className="bg-white text-black p-4 text-[14px] font-semibold cursor-pointer transition ease-in-out duration-300 hover:bg-[#c1c1c1]"
                  onClick={() => {
                    handleClick(item.name, item.number, item.code);
                    setIsOptionVisible((pev) => !pev);
                  }}
                >
                  {`${item.name} +${item.number}`}
                </li>
              </>
            ))}
            {searchMenus.length === 0 && (
              <div className="p-4 text-[14px] font-medium text-[#808080]">
                <FormattedMessage id="no_search_result" defaultMessage="No search result" />{' '}
              </div>
            )}
          </ul>
        </div>
      )}
    </>
  );
};

export default NationSelect;
